<template>
  <div v-if="loading" class="overlay">
    <div class="spinner" :style="spinnerStyle"></div>
    {{ $t("favorites.loading") }}
  </div>

  <div v-else class="bg-light">
    <div class="container">
      <div class="section-header-breadcrumb">
        <h2 class="title-page">
          <img :src="favoriteIcon" class="favorite" alt="favorite" />
          {{ $t("favorites.title") }}
        </h2>
        <label>{{ $t("favorites.breadcrumb") }}</label>
      </div>

      <div class="product-favoris-page">
        <div v-if="!products || products.length === 0" class="empty">
          {{ $t("favorites.empty") }}
        </div>

        <div v-else class="content col-12 my-4 text-left">
          <ProductFavoris :products="products" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import ProductFavoris from '@/components/products/ProductFavoris.vue';
import favoriteIcon from '@/assets/fav1.png';
import { useProductsStore } from '@/stores/productsStore';

const store = useProductsStore();

const size = '50px';
const color = '#3498db';

const spinnerStyle = computed(() => ({
  width: size,
  height: size,
  borderColor: `${color} transparent transparent transparent`,
}));

// ← SAFE: always returns array
const products = computed(() => store.getFavoriteProducts || []);
const loading = computed(() => store.loading);

onMounted(() => {
  store.fetchFavoriteProducts();
});
</script>

<style scoped>
  .product-favoris-page {
    text-align: center;
    max-width: 100%;
    min-height: 350px;
    .content {
      position: relative;
    }
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    position: relative;

    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }
    label {
      font-size: 15px;
      font-weight: normal;
      span {
        color: #1e347d;
      }
    }
  }

  @media (max-width: 768px) {
    .product-favoris-page {
      padding:15px;
    }
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
